import ReactD3MultiSeriesChart from "../../../../AxiomComponents/AxiomUI/ReactD3MultiSeriesChart/ReactD3MultiSeriesChart";

function groupedBarChartComponent(
  componentName,
  availableHeight,
  availableWidth,
  data,
  appName,
  appID,
  field,
  value,
  pointInfo,
  extraParams
) {
  const colors = [
    "#f28e2c",
    "#e15759",
    "#76b7b2",
    "#59a14f",
    "#edc949",
    "#af7aa1",
    "#ff9da7",
    "#9c755f",
    "#bab0ab",
    "#4e79a7",
  ];
  const totalPoints = data.filter((d) => {
    return isFinite(d.Growth) && d.Growth != null && d.Growth != "";
  }).length;

  const negativePoints = data.filter((d) => {
    const growth = isFinite(d.Growth) ? d.Growth * 100 : 0;
    return growth < 0;
  }).length;
  const title = [
    { text: `${negativePoints} out of ${totalPoints}`, class: "highlight" },
    { text: `months are having negative growth for ${field}` },
    { text: value, class: "highlight" },
  ];
  const chartData = {
    id: AxiomAPIs.generateUUID(16, "aA"),
    config: {
      width: availableWidth,
      height: availableHeight,
      title: {
        text: "",
      },
      subtitle: {
        text: "",
      },
      data: data,
      margins: {
        top: 10,
        right: 50,
        bottom: 30,
        left: 60,
      },
      xAxis: [
        {
          categories: data.map((d) => d[extraParams.distributionBy]),
          orient: "bottom",
          crosshair: false,
          lineColor: "#808080",
          lineWidth: 0.5,
          tickColor: "#808080",
          tickLineRequired: true,
          tickWidth: 0.5,
          labels: {
            style: {
              fontSize: "11px",
            },
            format: "",
            prefix: "",
            postfix: "",
          },
          gridLineWidth: 1,
        },
      ],
      yAxis: [
        {
          orient: "left",
          title: {
            text: "",
          },
          zeroBase: true,
          crosshair: false,
          lineColor: "#808080",
          lineWidth: 0.01,
          tickColor: "#808080",
          tickLineRequired: false,
          ticks: 5,
          tickWidth: 0.5,
          stackLabels: {},
          labels: {
            style: {
              color: "white",
              fontSize: "11px",
            },
            format: "0,0.[0]",
            prefix: "",
            postfix: "",
          },
        },
      ],
      series: extraParams.groups.map((s, i) => {
        return {
          type: "column",
          yAxis: 0,
          name: s,
          fillColor: colors[i % colors.length], //
          data: data.map((d) => {
            return +d[s];
          }),
          dataLabels: {
            enabled: false,
            style: {
              fill: "white",
              fontSize: "12px",
            },
          },
          marker: {},
          tooltip: true,
          tooltipPosition: "cursor",
          tooltipStyle: {
            valuePrefix: "",
            labelFontSize: "12px",
            labelFontColor: "#808080",
            labelFontFamily: "",
            valueFontSize: "12px",
            valueFontColor: "#808080",
            valueFontFamily: "",
            valuePostfix: "",
          },
          hoverStyle: {
            labelStyle: {
              fontSize: "14px",
              fontWeight: "bold",
              color: "green",
            },
            barStyle: {
              fill: "#4AA4B8",
            },
          },
        };
      }),
      legend: [],
    },
  };
  const component = (
    <ReactD3MultiSeriesChart {...chartData} appName={appName} appID={appID} componentID="0" />
  );
  return { title, component };
}

module.exports = groupedBarChartComponent;
